import { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { warningNotify } from "./Components/ToastComponent/ToastNotification";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./Components/Theme/theme";

import "./App.css";

// Misc ---------------------------------------------------------------------------------------------------------------------------------------------------------------

import AdminErrorPage from "./Components/Suspense/AdminErrorPage";
import Loader from "./Components/Suspense/Loader";

// Navbar -------------------------------------------------------------------------------------------------------------------------------------------------------------

import NavbarSidebarLayoutAdmin from "./Components/NavBar/NavbarSidebarLayoutAdmin";
import NavbarSidebarLayoutCandidate from "./Components/NavBar/NavbarSidebarLayoutCandidate";
import NavbarSidebarLayoutClient from "./Components/NavBar/NavbarSidebarLayoutClient";

// Login --------------------------------------------------------------------------------------------------------------------------------------------------------------

import LoginPage from "./Views/Login/LoginPage";
import LoginPage2 from "./Views/Login/LoginPage2";

// Admin --------------------------------------------------------------------------------------------------------------------------------------------------------------

import AdminDashboard from "./Components/Dashboard/AdminDashboard";

import AddClient from "./Views/Clients/AddClient";
import EditClients from "./Views/Clients/EditClients";
import ListClients from "./Views/Clients/ViewClient";
import ClientDetails from "./Views/Clients/ClientDetails";
import ClientFieldPrivilege from "./Views/Role/ClientFieldPrivilege";

import AddStaff from "./Views/Staff/AddStaff";
import EditStaff from "./Views/Staff/EditStaff";
import ListStaff from "./Views/Staff/ListStaff";
import StaffDetails from "./Views/Staff/StaffDetails";

import AddCandidate from "./Views/Candidate/AddCandidate";
import EditCandidate from "./Views/Candidate/EditCandidate";
import ListCandidate from "./Views/Candidate/ListCandidate";
import CandidateProfile from "./Views/Candidate/CandidateProfile";

import CreateJob from "./Views/Jobs/CreateJob";
import EditJob from "./Views/Jobs/EditJob";
import JobDetails from "./Views/Jobs/JobDetails";
import JobListing from "./Views/Jobs/JobListing";

import CreateJobLinking from "./Views/JobLinking/CreateJobLinking";
import EditJobLinking from "./Views/JobLinking/EditJobLinking";

import AddProfession from "./Views/Lookups/AddLookups/AddProfession";
import EditProfession from "./Views/Lookups/EditLookups/EditProfession";
import ProfessionList from "./Views/Lookups/ViewLookups/ProfessionList";

import AddQualification from "./Views/Lookups/AddLookups/AddQualification";
import EditQualification from "./Views/Lookups/EditLookups/EditQualification";
import QualificationList from "./Views/Lookups/ViewLookups/QualificationList";

import AddRecruitmentCountry from "./Views/Lookups/AddLookups/AddRecruitmentCountry";
import EditRecruitmentCountry from "./Views/Lookups/EditLookups/EditRecruitmentCountry";
import RecruitmentCountryList from "./Views/Lookups/ViewLookups/RecruitmentCountryList";

import AddDesignation from "./Views/Lookups/AddLookups/AddDesignation";
import EditDesignation from "./Views/Lookups/EditLookups/EditDesignation";
import DesignationList from "./Views/Lookups/ViewLookups/DesignationList";

import AddEmploymentType from "./Views/Lookups/AddLookups/AddEmploymentType";
import EmploymentTypeList from "./Views/Lookups/ViewLookups/EmploymentTypeList";
import EditEmploymentType from "./Views/Lookups/EditLookups/EditEmploymentType";

import CompanyTypeList from "./Views/Lookups/ViewLookups/CompanyTypeList";
import EditCompanyType from "./Views/Lookups/EditLookups/EditCompanyType";
import AddCompanyType from "./Views/Lookups/AddLookups/AddCompanyType";

import AddDocument from "./Views/Lookups/AddLookups/AddDocument";
import EditDocument from "./Views/Lookups/EditLookups/EditDocument";
import DocumentList from "./Views/Lookups/ViewLookups/DocumentList";

import AddBranch from "./Views/Lookups/AddLookups/AddBranch";
import EditBranch from "./Views/Lookups/EditLookups/EditBranch";
import BranchList from "./Views/Lookups/ViewLookups/BranchList";

import AddDepartment from "./Views/Lookups/AddLookups/AddDepartment";
import DepartmentList from "./Views/Lookups/ViewLookups/DepartmentList";
import EditDepartment from "./Views/Lookups/EditLookups/EditDepartment";

import SalaryPayList from "./Views/Lookups/ViewLookups/SalaryPayList";
import AddSalaryPay from "./Views/Lookups/AddLookups/AddSalaryPay";
import EditSalaryPay from "./Views/Lookups/EditLookups/EditSalaryPay";

import YearsOfExperienceList from "./Views/Lookups/ViewLookups/YearsOfExperienceList";
import EditYearsOfExperience from "./Views/Lookups/EditLookups/EditYearsOfExperience";
import AddYearsOfExperience from "./Views/Lookups/AddLookups/AddYearsOfExperience";

import AdditionalRequirementList from "./Views/Lookups/ViewLookups/AdditionalRequirementList";
import EditAdditionalRequirements from "./Views/Lookups/EditLookups/EditAdditionalRequirements";
import AddAdditionalRequirements from "./Views/Lookups/AddLookups/AddAdditionalRequirements";

import AddRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/AddRecruitmentProcedure";
import CloneRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/CloneRecruitmentProcedure";
import RecruitmentProcedureList from "./Views/ProcessFlow/RecruitmentProcedure/RecruitmentProcedureList";
import ViewRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/ViewRecruitmentProcedure";

import RecruitmentProcedureMappingList from "./Views/ProcessFlow/RecruitmentProcedureMapping/RecruitmentProcedureMappingList";
import AddRecruitmentProcedureMapping from "./Views/ProcessFlow/RecruitmentProcedureMapping/AddRecruitmentProcedureMapping";

import AddDocumentProcedure from "./Views/ProcessFlow/DocumentProcedure/AddDocumentProcedure";
import EditDocumentProcedure from "./Views/ProcessFlow/DocumentProcedure/EditDocumentProcedure";
import DocumentProcedureList from "./Views/ProcessFlow/DocumentProcedure/DocumentProcedureList";

import Reports from "./Views/Reports/Report";

import Privilege from "./Views/Role/Privilege";

import AddRole from "./Views/Role/AddRole";
import EditRole from "./Views/Role/EditRole";
import ListRole from "./Views/Role/ListRole";

import AuditLog from "./Components/Audit/Audit";

import Profile from "./Components/Dashboard/Profile";

import Settings from "./Components/Settings/Settings";

// Candidate ----------------------------------------------------------------------------------------------------------------------------------------------------------

import CandidateDash from "./CandidateView/Dashboard/CandidateDash";
import CandidateNotifications from "./CandidateView/Notifications/CandidateNotifications";
import CandidateProfilePage from "./CandidateView/CandidateProfile/CandidateProfilePage";
import CandidateJobs from "./CandidateView/Dashboard/CandidateJobs";
import CandidateSummary from "./CandidateView/Dashboard/CandidateSummary";

// Client -------------------------------------------------------------------------------------------------------------------------------------------------------------

import ClientDash from "./ClientView/Dashboard/ClientDash";
import ClientJobList from "./ClientView/Jobs/ClientJobList";
import ClientJobDetails from "./ClientView/Jobs/ClientJobDetails";
import ClientJobApplicantList from "./ClientView/Jobs/ClientJobApplicantList";
import ClientCandidateList from "./ClientView/Candidate/ClientCandidateList";
import ClientCandidateProfile from "./ClientView/Candidate/ClientCandidateProfile";
import DeployedClientCandidateList from "./ClientView/Candidate/DeployedClientCandidateList";
import ClientProfilePortal from "./ClientView/ClientProfile/ClientProfilePortal";
import EditRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/EditRecruitmentProcedure";
import RecruitmentProcedureListNew from "./Views/ProcessFlow/RecruitmentProcedure/RecruitmentProcedureListNew";

// --------------------------------------------------------------------------------------------------------------------------------------------------------------------

const AdminComponents = () => {
  const [isAdmin, setIsAdmin] = useState(true);
  const [privilegeData, setprivilegeData] = useState([]);

  function hasClientAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData?.length == 0) return true;
    return privilegeData?.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("client");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasClientEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("client");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasClientViewprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("client");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasStaffAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasStaffEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasStaffViewprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasCandAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasCandEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasCandViewprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasJobAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("job");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasJobEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("job");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasJobViewprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("job");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned == true
      );
    });
  }

  function hasRecProcAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasRecProcEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasRecProcViewprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned == true
      );
    });
  }

  function hasRecProcMapAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure mapping");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasDocCheckAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document checklist");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasDocCheckEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document checklist");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasRolesAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("roles");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasRolesEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName.toLowerCase().includes("roles");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasProfAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("profession");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasProfEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("profession");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasQualAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("qualification");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasQualEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("qualification");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasDesigAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("designation");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasDesigEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("designation");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hascomptypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("company type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hascomptypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("company type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasemptypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("employment type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasemptypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("employment type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasdoctypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasdoctypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("document type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasreccounAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment country");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasreccounEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("recruitment country");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasbranchAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("branch");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasbranchEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("branch");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasdepartAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("department");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasdepartEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("department");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasaddreqAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("additional requirement");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasaddreqEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("additional requirement");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hassalpayAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("salary pay");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hassalpayEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("salary pay");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasyoeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("year of experience");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasyoeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("year of experience");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasAuditLog(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("audit log");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasReport(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("reports");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  function hasSettingsView(privilegeData) {
    if (isAdmin) return true;
    if (privilegeData.length == 0) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("settings");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  return (
    <NavbarSidebarLayoutAdmin 
      isAdmin={isAdmin} 
      setIsAdmin={setIsAdmin} 
      privilegeData={privilegeData} 
      setprivilegeData={setprivilegeData}
    >
      <Routes>
                                                          {/* Admin Dashboard */}
                                                          <Route path="/" element={<AdminDashboard/>} />

                                                          {/* Client CRUD */}
                                                          <Route path="/Clients" element={<ListClients isAdmin={isAdmin}/>} />
          {hasClientAddprivilege(privilegeData)        && <Route path="/Clients/Add" element={<AddClient />} />}
          {hasClientEditprivilege(privilegeData)       && <Route path="/Clients/Edit/:id" element={<EditClients />} />}
          {hasClientViewprivilege(privilegeData)       && <Route path="/Clients/View/:id" element={<ClientDetails />} />}

                                                          {/* Staff CRUD */}
                                                          <Route path="/Staffs" element={<ListStaff isAdmin={isAdmin}/>} />
          {hasStaffAddprivilege(privilegeData)         && <Route path="/Staffs/Add" element={<AddStaff />} />}
          {hasStaffEditprivilege(privilegeData)        && <Route path="/Staffs/Edit/:id" element={<EditStaff />} />}
          {hasStaffViewprivilege(privilegeData)        && <Route path="/Staffs/View/:id" element={<StaffDetails />} />}
  
                                                          {/* Candidate CRUD */}
                                                          <Route path="/Candidates" element={<ListCandidate isAdmin={isAdmin}/>} />
          {hasCandAddprivilege(privilegeData)          && <Route path="/Candidates/Add" element={<AddCandidate />} />}
          {hasCandEditprivilege(privilegeData)         && <Route path="/Candidates/Edit/:id" element={<EditCandidate />} />}
          {hasCandViewprivilege(privilegeData)         && <Route path="/Candidates/View/:id" element={<CandidateProfile />} />}

                                                          {/* Jobs Linking CRUD */}
          {hasCandViewprivilege(privilegeData)         && <Route path="/JobLinking/Add/:id" element={<CreateJobLinking />} />}
          {hasCandViewprivilege(privilegeData)         && <Route path="/JobLinking/Edit/:id" element={<EditJobLinking />} />}

                                                          {/* Job CRUD */}
                                                          <Route path="/Jobs" element={<JobListing isAdmin={isAdmin}/>} />
          {hasJobAddprivilege(privilegeData)           && <Route path="/Jobs/Add" element={<CreateJob />} />}
          {hasJobEditprivilege(privilegeData)          && <Route path="/Jobs/Edit/:id" element={<EditJob />} />}
          {hasJobViewprivilege(privilegeData)          && <Route path="/Jobs/View/:id" element={<JobDetails />} />}
          {hasJobViewprivilege(privilegeData)          && <Route path="/Jobs/Applicants/:id/:title" element={<ClientJobApplicantList/>} />}
                                                         
                                                          {/* Process Flow - Recruitment Procedure */}
                                                          <Route path="/RecruitmentProcedure" element={<RecruitmentProcedureListNew isAdmin={isAdmin} />}/>
          {hasRecProcAddprivilege(privilegeData)       && <Route path="/RecruitmentProcedure/Add" element={<AddRecruitmentProcedure />}/>}
          {hasRecProcEditprivilege(privilegeData)      && <Route path="/RecruitmentProcedure/Clone/:id" element={<CloneRecruitmentProcedure />}/>}
          {hasRecProcEditprivilege(privilegeData)      && <Route path="/RecruitmentProcedure/Edit/:id" element={<EditRecruitmentProcedure />}/>}
          {hasRecProcViewprivilege(privilegeData)      && <Route path="/RecruitmentProcedure/View/:id" element={<ViewRecruitmentProcedure />}/>}

                                                          {/* Recruitment Procedure Mapping */}
                                                          <Route path="/RecruitmentMappingProcedure" element={<RecruitmentProcedureMappingList isAdmin={isAdmin}/>}/>
          {hasRecProcMapAddprivilege(privilegeData)    && <Route path="/RecruitmentMappingProcedure/Add" element={<AddRecruitmentProcedureMapping />}/>}

                                                          {/* Document Procedure */}
                                                          <Route path="/DocumentProcedure" element={<DocumentProcedureList isAdmin={isAdmin}/>} />
          {hasDocCheckAddprivilege(privilegeData)      && <Route path="/DocumentProcedure/Add" element={<AddDocumentProcedure />}/>}
          {hasDocCheckEditprivilege(privilegeData)     && <Route path="/DocumentProcedure/Edit/:pid/:cid" element={<EditDocumentProcedure />}/>}

                                                          {/* Roles and privileges */}
                                                          <Route path="/Roles" element={<ListRole isAdmin={isAdmin}/>} />
          {hasRolesAddprivilege(privilegeData)         && <Route path="/Roles/Add" element={<AddRole />} />}
          {hasRolesEditprivilege(privilegeData)        && <Route path="/Roles/Edit/:id" element={<EditRole />} />}

                                                          {/* Lookups */}
                                                          <Route path="/ProfessionLookup" element={<ProfessionList isAdmin={isAdmin}/>} /> 
          {hasProfAddprivilege(privilegeData)          && <Route path="/ProfessionLookup/Add" element={<AddProfession />} /> }
          {hasProfEditprivilege(privilegeData)         && <Route path="/ProfessionLookup/Edit/:id" element={<EditProfession />}/> }

                                                          <Route path="/QualificationLookup" element={<QualificationList isAdmin={isAdmin}/>}/>
          {hasQualAddprivilege(privilegeData)          && <Route path="/QualificationLookup/Add" element={<AddQualification />}/>}
          {hasQualEditprivilege(privilegeData)         && <Route path="/QualificationLookup/Edit/:id" element={<EditQualification />}/> }

                                                          <Route path="/DesignationLookup" element={<DesignationList isAdmin={isAdmin}/>} /> 
          {hasDesigAddprivilege(privilegeData)         && <Route path="/DesignationLookup/Add" element={<AddDesignation />}/>}
          {hasDesigEditprivilege(privilegeData)        && <Route path="/DesignationLookup/Edit/:id" element={<EditDesignation />}/> }

                                                          <Route path="/CompanyTypeLookup" element={<CompanyTypeList isAdmin={isAdmin}/>} />
          {hascomptypeAddprivilege(privilegeData)      && <Route path="/CompanyTypeLookup/Add" element={<AddCompanyType />}/> }
          {hascomptypeEditprivilege(privilegeData)     && <Route path="/CompanyTypeLookup/Edit/:id" element={<EditCompanyType />}/>}

                                                          <Route path="/EmploymentTypeLookup" element={<EmploymentTypeList isAdmin={isAdmin}/>}/> 
          {hasemptypeAddprivilege(privilegeData)       && <Route path="/EmploymentTypeLookup/Add" element={<AddEmploymentType />}/> }
          {hasemptypeEditprivilege(privilegeData)      && <Route path="/EmploymentTypeLookup/Edit/:id" element={<EditEmploymentType />}/> }

                                                          <Route path="/DocumentLookup" element={<DocumentList isAdmin={isAdmin}/>} />
          {hasdoctypeAddprivilege(privilegeData)       && <Route path="/DocumentLookup/Add" element={<AddDocument />} /> }
          {hasdoctypeEditprivilege(privilegeData)      && <Route path="/DocumentLookup/Edit/:id" element={<EditDocument />}/> }
          
                                                          <Route path="/RecruitmentCountryLookup" element={<RecruitmentCountryList isAdmin={isAdmin}/>}/> 
          {hasreccounAddprivilege(privilegeData)       && <Route path="/RecruitmentCountryLookup/Add" element={<AddRecruitmentCountry />}/>}
          {hasreccounEditprivilege(privilegeData)      && <Route path="/RecruitmentCountryLookup/Edit/:id" element={<EditRecruitmentCountry />}/> }

                                                          <Route path="/BranchLookup" element={<BranchList isAdmin={isAdmin}/>} />
          {hasbranchAddprivilege(privilegeData)        && <Route path="/BranchLookup/Add" element={<AddBranch />} /> }
          {hasbranchEditprivilege(privilegeData)       && <Route path="/BranchLookup/Edit/:id" element={<EditBranch />} />}

                                                          <Route path="/DepartmentLookup" element={<DepartmentList isAdmin={isAdmin}/>} />
          {hasdepartAddprivilege(privilegeData)        && <Route path="/DepartmentLookup/Add" element={<AddDepartment />} /> }
          {hasdepartEditprivilege(privilegeData)       && <Route path="/DepartmentLookup/Edit/:id" element={<EditDepartment />}/> }

                                                          <Route path="/AdditionalRequirementsLookup" element={<AdditionalRequirementList isAdmin={isAdmin}/>}/> 
          {hasaddreqAddprivilege(privilegeData)        && <Route path="/AdditionalRequirementsLookup/Add" element={<AddAdditionalRequirements />}/> }
          {hasaddreqEditprivilege(privilegeData)       && <Route path="/AdditionalRequirementsLookup/Edit/:id" element={<EditAdditionalRequirements />}/> }

                                                          <Route path="/SalaryPayLookup" element={<SalaryPayList isAdmin={isAdmin}/>} /> 
          {hassalpayAddprivilege(privilegeData)        && <Route path="/SalaryPayLookup/Add" element={<AddSalaryPay />} /> }
          {hassalpayEditprivilege(privilegeData)       && <Route path="/SalaryPayLookup/Edit/:id" element={<EditSalaryPay />}/> }

                                                          <Route path="/YearsOfExperienceLookup" element={<YearsOfExperienceList isAdmin={isAdmin}/>}/> 
          {hasyoeAddprivilege(privilegeData)           && <Route path="/YearsOfExperienceLookup/Add" element={<AddYearsOfExperience />}/> }
          {hasyoeEditprivilege(privilegeData)          && <Route path="/YearsOfExperienceLookup/Edit/:id" element={<EditYearsOfExperience />}/> }
          
                                                          {/* Audit Log */}
          {hasAuditLog(privilegeData)                  && <Route path="/AuditLog" element={<AuditLog isAdmin={isAdmin}/>} />}
          
                                                          {/* Reports */}
          {hasReport(privilegeData)                    && <Route path="/Reports" element={<Reports isAdmin={isAdmin}/>} />}

                                                          {/* Settings */}
          {hasSettingsView(privilegeData)              && <Route path="/Settings" element={<Settings isAdmin={isAdmin}/>}/> }

                                                          {/* Privilages */}
          {isAdmin                                     && <Route path="/Privileges" element={<Privilege />} />}
          {isAdmin                                     && <Route path="/Clientprivileges" element={<ClientFieldPrivilege />} />}
                                                          {/* Profile */}
          {!isAdmin                                    && <Route path="/Profile" element={<Profile />} />}

                                                          {/* Error Routing */}
                                                          <Route path="/*" element={<AdminErrorPage />} />
      </Routes>
    </NavbarSidebarLayoutAdmin>
  );
};

const CandidateComponents = () => {
  return (
    <NavbarSidebarLayoutCandidate>
      <Routes>
        <Route path="/" element={<CandidateDash />} />
        <Route path="/Jobs" element={<CandidateJobs />} />
        <Route path="/Notifications" element={<CandidateNotifications />} />
        <Route path="/Summary" element={<CandidateSummary />} />
        <Route path="/Profile" element={<CandidateProfilePage />} />
        <Route path="/*" element={<AdminErrorPage />} />
      </Routes>
    </NavbarSidebarLayoutCandidate>
  );
};

const ClientComponents = () => {
  return (
    <NavbarSidebarLayoutClient>
      <Routes>
        <Route path="/" element={<ClientDash />} />
        <Route path="/Jobs" element={<ClientJobList />} />
        <Route path="/Jobs/View/:id" element={<ClientJobDetails />} />
        <Route path="/Jobs/Applicants/:id/:title" element={<ClientJobApplicantList />}/>
        <Route path="/Candidates" element={<ClientCandidateList />} />
        <Route path="/Candidates/View" element={<ClientCandidateProfile />} />
        <Route path="/DeployedCandidates" element={<DeployedClientCandidateList />}/>
        <Route path="/Profile" element={<ClientProfilePortal />} />
        <Route path="/*" element={<AdminErrorPage />} />
      </Routes>
    </NavbarSidebarLayoutClient>
  );
};

function App() {
  const [role, setRole] = useState(null);
  const [loadContent, setLoadContent] = useState(false);

  useEffect(() => {
    const storedRole = localStorage.getItem("SWA_userRole") || sessionStorage.getItem("SWA_userRole"); // admin | client | candidate | null
    setRole(storedRole); // admin | client | candidate | null

    if (localStorage.getItem("sessionTimeoutNotified")) {
      warningNotify("Your session has expired. Please log in again.");

      localStorage.removeItem("sessionTimeoutNotified");

      if (localStorage?.getItem(`SWA_RememberPassword_loginUser`) == "client") {
        window.location.href = "#/Login/Client";
      } else if (
        localStorage?.getItem(`SWA_RememberPassword_loginUser`) == "candidate"
      ) {
        window.location.href = "#/Login/Candidate";
      } else if (
        localStorage?.getItem(`SWA_RememberPassword_loginUser`) == "admin"
      ) {
        window.location.href = "#/Login/Admin";
      } else {
        window.location.href = "/";
      }
    }

    setTimeout(() => {
      setLoadContent(true);
    }, 900);
  }, []);

  if (!loadContent) return <Loader />;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ToastContainer />
        <Routes>
          <Route
            path="/Login/Admin"
            element={<LoginPage  setRole={setRole} loginUser={`admin`} />}
          />
          <Route
            path="/Login/Candidate"
            element={<LoginPage2 setRole={setRole} loginUser={`candidate`} />}
          />
          <Route
            path="/Login/Client"
            element={<LoginPage2 setRole={setRole} loginUser={`client`} />}
          />

          <Route
            path="/*"
            element={
              role == "candidate" ? (
                <CandidateComponents />
              ) : role == "client" ? (
                <ClientComponents />
              ) : role == "admin" ? (
                <AdminComponents />
              ) : (
                <Navigate to="/Login/Candidate" />
              )
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
